import { __assign, __spreadArray } from "tslib";
var LogHelper = /** @class */ (function () {
    function LogHelper() {
    }
    Object.defineProperty(LogHelper, "setDisableStyle", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (boo) {
            if (boo === void 0) { boo = true; }
            this.disableStyle = boo;
        }
    });
    Object.defineProperty(LogHelper, "disableLogging", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.loggingDisabled = true;
        }
    });
    Object.defineProperty(LogHelper, "log", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.loggingDisabled === false) {
                this.logToWindow.apply(this, args);
                console.log.apply(console, args);
            }
        }
    });
    Object.defineProperty(LogHelper, "logToWindow", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            //@ts-ignore
            if (window) {
                //@ts-ignore
                if (!window.UCF) {
                    //@ts-ignore
                    window.UCF = {};
                }
                //@ts-ignore
                if (!window.UCF.logList) {
                    //@ts-ignore
                    window.UCF.logList = [];
                }
                //@ts-ignore
                var logList = window.UCF.logList;
                logList.push(__spreadArray([], args, true));
            }
        }
    });
    Object.defineProperty(LogHelper, "logSystem", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            if (!this.disableStyle) {
                options = __assign({ title: 'UNKNOWN', subtitle: undefined, color: 'black', backgroundColor: 'yellow' }, options);
                this.log.apply(this, __spreadArray(["%c" + options.title + "[" + options.subtitle + "]", "background-color: " + options.backgroundColor + "; color: " + options.color + ";"], args, false));
            }
            else {
                this.log.apply(this, __spreadArray([options.title + "[" + options.subtitle + "]"], args, false));
            }
        }
    });
    Object.defineProperty(LogHelper, "logSuccess", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (title, subtitle) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            this.logSystem.apply(this, __spreadArray([{
                    title: title,
                    subtitle: subtitle,
                    color: 'white',
                    backgroundColor: 'green',
                }], args, false));
        }
    });
    Object.defineProperty(LogHelper, "logError", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (title, subtitle) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            this.logSystem.apply(this, __spreadArray([{
                    title: title,
                    subtitle: subtitle,
                    color: 'white',
                    backgroundColor: 'red',
                }], args, false));
        }
    });
    Object.defineProperty(LogHelper, "logInfo", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (title, subtitle) {
            var args = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args[_i - 2] = arguments[_i];
            }
            this.logSystem.apply(this, __spreadArray([{
                    title: title,
                    subtitle: subtitle,
                    color: 'black',
                    backgroundColor: 'yellow',
                }], args, false));
        }
    });
    Object.defineProperty(LogHelper, "loggingDisabled", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(LogHelper, "disableStyle", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    return LogHelper;
}());
export { LogHelper };
//# sourceMappingURL=data:application/json;base64,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